(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('PropertyController', PropertyController);

    PropertyController.$inject = ['$scope', 'Principal', 'LoginService', '$state','User','MessageService','ProductCategory', 'ParseLinks', '$uibModal','$uibModalInstance', 'entity'];

    function PropertyController ($scope, Principal, LoginService, $state,User,MessageService, ProductCategory, ParseLinks, $uibModal, $uibModalInstance, entity) {
        var vm = this;
        vm.property = entity;
        //生成
        $scope.save = function () {
            var _arr = [];
            for(var i=0; i<vm.property.length; i++){
                var _arr1 = [];
                for(var j=0; j<vm.property[i].itemValues.length; j++){
                    if(vm.property[i].itemValues[j].checked){
                        var _obj = vm.property[i].itemValues[j].name;
                        _arr1.push(_obj)
                    }
                }
                _arr.push(_arr1)
            }
            $uibModalInstance.close(_arr);
        }
        //取消
        $scope.modalHide = function () {
            $uibModalInstance.close();
        }
    }
})();
